import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type {
  ReportListParams,
  ReportListResponse,
  ReportItem,
  PendingReportsCountResponse,
  RejectReportInput,
  AttachmentUrlResponse,
} from '@/types/reports';

function serializeListParams(p?: ReportListParams): Record<string, string | number | undefined> {
  if (!p) return {};
  const out: Record<string, string | number | undefined> = {};
  for (const [k, v] of Object.entries(p)) {
    if (v === undefined || v === null || v === '') continue;
    out[k] = v as string | number;
  }
  return out;
}

export async function listReports(
  params?: ReportListParams,
): Promise<ReportListResponse> {
  const { data } = await client.get<ApiResponse<ReportListResponse>>(
    '/api/v1/dashboard/reports',
    { params: serializeListParams(params) },
  );
  return data.data;
}

export async function getReportDetail(id: string): Promise<ReportItem> {
  const { data } = await client.get<ApiResponse<ReportItem>>(
    `/api/v1/dashboard/reports/${id}`,
  );
  return data.data;
}

export async function getPendingCount(): Promise<PendingReportsCountResponse> {
  const { data } = await client.get<ApiResponse<PendingReportsCountResponse>>(
    '/api/v1/dashboard/reports/pending/count',
  );
  return data.data;
}

export async function approveReport(id: string): Promise<void> {
  await client.post(`/api/v1/dashboard/reports/${id}/approve`);
}

export async function rejectReport(id: string, input: RejectReportInput): Promise<void> {
  await client.post(`/api/v1/dashboard/reports/${id}/reject`, input);
}

export async function fetchAttachmentBlob(url: string): Promise<Blob> {
  const { data } = await client.get<Blob>(url, { responseType: 'blob' });
  return data;
}

// SPEC-018: ask the API for a short-lived presigned S3 URL the browser can fetch directly.
export async function fetchAttachmentUrl(
  reportId: string,
  attachmentId: string,
): Promise<AttachmentUrlResponse> {
  const { data } = await client.get<ApiResponse<AttachmentUrlResponse>>(
    `/api/v1/dashboard/reports/${reportId}/attachments/${attachmentId}/url`,
  );
  return data.data;
}
